import React, { useState } from 'react';
import { AlertTriangle, Phone, X } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { emergencyAPI } from '../lib/api';
import { toast } from 'sonner';

export const PanicButton = ({ serviceType, serviceId, userLocation, onAlertSent }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [sending, setSending] = useState(false);

  const handlePanic = async () => {
    if (!userLocation) {
      toast.error('No se pudo obtener tu ubicación');
      return;
    }

    setSending(true);
    try {
      const response = await emergencyAPI.createAlert({
        service_type: serviceType,
        service_id: serviceId,
        location: userLocation,
        message: 'Alerta de emergencia activada por el usuario'
      });

      toast.success('🚨 Alerta enviada. Soporte ha sido notificado.');
      setShowConfirm(false);
      if (onAlertSent) onAlertSent(response.data);
    } catch (error) {
      toast.error('Error al enviar alerta. Intenta llamar al 911.');
    } finally {
      setSending(false);
    }
  };

  if (showConfirm) {
    return (
      <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
        <Card className="w-full max-w-sm bg-red-950/90 border-red-500/50 animate-slide-up">
          <CardContent className="p-6 text-center">
            <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-4 animate-pulse">
              <AlertTriangle className="w-10 h-10 text-red-500" />
            </div>
            
            <h2 className="text-xl font-bold text-white mb-2">¿Confirmar Emergencia?</h2>
            <p className="text-white/70 text-sm mb-6">
              Se enviará tu ubicación actual y datos del viaje a nuestro equipo de soporte.
            </p>

            <div className="space-y-3">
              <Button
                onClick={handlePanic}
                disabled={sending}
                className="w-full h-14 bg-red-600 hover:bg-red-700 text-white font-bold text-lg"
                data-testid="confirm-emergency-btn"
              >
                {sending ? (
                  <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" />
                ) : (
                  <>
                    <AlertTriangle className="w-5 h-5 mr-2" />
                    CONFIRMAR EMERGENCIA
                  </>
                )}
              </Button>

              <Button
                onClick={() => setShowConfirm(false)}
                variant="ghost"
                className="w-full h-12 text-white/70 hover:text-white"
              >
                <X className="w-5 h-5 mr-2" />
                Cancelar
              </Button>

              <a
                href="tel:911"
                className="flex items-center justify-center gap-2 w-full h-12 bg-white/10 rounded-xl text-white hover:bg-white/20 transition-colors"
              >
                <Phone className="w-5 h-5" />
                Llamar al 911
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <Button
      onClick={() => setShowConfirm(true)}
      className="fixed bottom-24 right-4 lg:bottom-8 lg:right-8 w-16 h-16 rounded-full bg-red-600 hover:bg-red-700 shadow-lg shadow-red-600/30 z-40"
      data-testid="panic-button"
    >
      <AlertTriangle className="w-8 h-8 text-white" />
    </Button>
  );
};

export default PanicButton;
